enum ActionTypes {
  SET_IS_BODY_SCROLLABLE = 'gofre/ui/SET_IS_BODY_SCROLLABLE',
}

export default ActionTypes;
